import React, { useState } from 'react';
import MainCalculatorsList from '../MainCalculators';
import RelatedLinks from '../RelatedLinks';
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
import { SERVER_URL } from '../ConstantsEN';
import { BMR_EndPoint } from '../ConstantsEN';
import { CalculatorsType } from '../ConstantsEN';
import BMRTable from './BMRTable';
const TITLE = 'Basal Metabolic Rate Calculator - BMR Calculator';
const DESCRIPTION = 'Our free and advanced BMR Calculator relies on the known BMR formula to calculate Basal Metabolic Rate (BMR), the number of calories your body needs at rest to maintain basic functions such as breathing, circulation, and other essential organ functions. BMR calculator factors in weight, height, age, gender, and body fat percentage. BMR is calculated using different equations like the Harris-Benedict Equation, Mifflin-St Jeor Equation, and more. BMR is important for estimating daily energy needs, planning diets, and exercise programs.';
const KEYWORDS = 'Basal Metabolic Rate Calculator, BMR Calculator, Body Basal Metabolic Rate, How to Calculate BMR, BMR and Caloric Intake, BMR Calculation Formula, What is BMR?, Importance of BMR for Health, How Does BMR Affect Weight Loss?, Ways to Increase BMR';
const OG_URL = 'https://do-calculate.com/calculator/en/bmr/';
const apiEndpoint = `${SERVER_URL}/${BMR_EndPoint}`;
function BMRCalculator() {
    const [weight, setWeight] = useState('');
    const [height, setHeight] = useState('');
    const [age, setAge] = useState('');
    const [gender, setGender] = useState('');
    const [result, setRestul] = useState(null);
    const [error, setError] = useState(null);
    const [statusCode, setStatusCode] = useState(null);
    const [classification, setClassification] = useState(null)
    const [formula, setFormula] = useState('harrisBenedictRevised');
    const [bodyFatPercentage, setBodyFatPercentage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const handleWeightChange = (event) => {
        setWeight(event.target.value);
    };
    const handleHeightChange = (event) => {
        setHeight(event.target.value);
    };
    const handleAgeChange = (event) => {
        setAge(event.target.value);
    };
    const handleGenderChange = (event) => {
        setGender(event.target.value);
    };
    const handleFormulaChange = (event) => {
        setFormula(event.target.value);
    };
    const handleBodyFatPercentageChange = (event) => {
        setBodyFatPercentage(event.target.value);
    };
    const calculateBMR = async () => {
        setIsLoading(true);
        try {
            const response = await fetch(apiEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ weight, height, age, gender, formula, bodyFatPercentage }),
            });
            const data = await response.json();
            setStatusCode(response.status);
            if (response.ok) {
                setRestul(data.result);
                setError(null);
                setClassification(data.result.classification);
            } else {
                setRestul(null);
                setError(data.error);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <div>
            <SharedHelmet
                TITLE={TITLE}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
            />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: '40px' }}>
                        <h1 style={{ fontSize: '16px' }}>{TITLE}</h1>
                    </div>
                    <div className="border border-light">
                        <div className="row">
                            <div>
                                This BMR Calculator calculates your Basal Metabolic Rate (BMR), which is the energy your body needs at complete rest to maintain basic functions such as breathing, circulation, and other essential organ functions. BMR calculator is affected by factors like weight, height, age, gender, and body fat percentage. BMR is calculated using different equations like the Harris-Benedict Equation and Mifflin-St Jeor Equation. BMR is important for estimating daily energy needs, planning diets, and exercise programs.
                                <br />
                                <hr />
                            </div>
                            <br />
                        </div>
                        <MobileUnderCalAds />
                        <div className="row">
                            <div className="col-sm-12 col-md-5 calculatorStyle">
                                <div className='p-3 mb-2 bg-success text-white'>
                                    Basal Metabolic Rate - BMR Calculator
                                </div>
                                <hr />
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor='height' className="form-label ms-2">Height</label>
                                    </b>
                                    <input
                                        type="number"
                                        id="weightNumber"
                                        value={height}
                                        onChange={handleHeightChange}
                                        className="form-control ml-2"
                                        style={{ width: '75px' }}
                                        placeholder="175"
                                    />
                                    <div className="input-group-append">
                                        <span className="input-group-text">cm</span>
                                    </div>
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor='weightNumber' className="form-label ms-2">Weight</label>
                                    </b>
                                    <input
                                        type="number"
                                        id="weightNumber"
                                        value={weight}
                                        onChange={handleWeightChange}
                                        className="form-control ml-2"
                                        style={{ width: '75px' }}
                                        placeholder="65"
                                    />
                                    <div className="input-group-append">
                                        <span className="input-group-text">kg</span>
                                    </div>
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor='age' className="form-label ms-2">Age</label>
                                    </b>
                                    <input
                                        type="number"
                                        id="age"
                                        value={age}
                                        onChange={handleAgeChange}
                                        className="form-control"
                                        style={{ width: '75px' }}
                                        placeholder="6"
                                        min="2"
                                        max="20"
                                    />
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label >Gender</label>
                                    </b>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            name="gender"
                                            value="male"
                                            id='male'
                                            checked={gender === "male"}
                                            onChange={handleGenderChange}
                                            className="form-check-input"
                                        />
                                        <label htmlFor='male' className="form-check-label">
                                            Male
                                        </label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            name="gender"
                                            value="female"
                                            id="female"
                                            checked={gender === "female"}
                                            onChange={handleGenderChange}
                                            className="form-check-input"
                                        />
                                        <label htmlFor='female' className="form-check-label" >
                                            Female
                                        </label>
                                    </div>
                                </div>
                                <br />
                                <div>
                                    <b>
                                        <label htmlFor="select" className="form-label ms-2">Choose Formula</label>
                                    </b>
                                    <select id="select" className="form-select" value={formula} onChange={handleFormulaChange}>
                                        <option value="harrisBenedictRevised">Harris Benedict Equation (Revised)</option>
                                        <option value="harrisBenedictOriginal">Harris-Benedict Equation (Original)</option>
                                        <option value="mifflinStJeor">Mifflin-St Jeor</option>
                                        <option value="schofield">Schofield</option>
                                        <option value="oxford">Oxford</option>
                                        <option value="katchMcArdle">Katch-McArdle</option>
                                        <option value="cunningham">Cunningham</option>
                                    </select>
                                </div>
                                <br />
                                {(formula === 'katchMcArdle' || formula === 'cunningham') && (
                                    <div className="form-group d-flex align-items-center">
                                        <b>
                                            <label className="form-label ms-2">Body Fat Percentage</label>
                                        </b>
                                        <input
                                            type="number"
                                            id="bodyFatPercentage"
                                            value={bodyFatPercentage}
                                            onChange={handleBodyFatPercentageChange}
                                            className="form-control"
                                            style={{ width: '75px' }}
                                            placeholder="6"
                                            min="2"
                                            max="20"
                                        />
                                        <div className="input-group-append">
                                            <span className="input-group-text">%</span>
                                        </div>
                                        <br />
                                    </div>
                                )}
                                <hr />
                                <button className="btn btn-success" style={{ fontSize: '20px' }} onClick={
                                    calculateBMR} disabled={isLoading}>
                                    {isLoading ? (
                                        <div className="spinner-border spinner-border-sm" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    ) : (
                                        'Calculate'
                                    )}
                                </button>
                            </div>
                            <div className="col-sm-12 col-md-7">
                                {result && (
                                    <div>
                                        <div className="alert alert-success">
                                            <h5>Results:</h5>
                                            Your Basal Metabolic Rate (BMR): {result.bmr} calories.
                                        </div>
                                        <hr />
                                        <BMRTable formula={formula}
                                            bmr={result.bmr}
                                            Sedentary={result.DailyCalorieNeeded.Sedentary}
                                            Exercise1_3={result.DailyCalorieNeeded.Exercise1_3}
                                            Exercise4_5={result.DailyCalorieNeeded.Exercise4_5}
                                            DailyExercise={result.DailyCalorieNeeded.DailyExercise}
                                            IntenseExercise={result.DailyCalorieNeeded.IntenseExercise}
                                            VeryIntenseExercise={result.DailyCalorieNeeded.VeryIntenseExercise}
                                        ></BMRTable>  <br />
                                        <div className="alert alert-warning" >
                                            <ul style={{ fontSize: '13px' }}>
                                                <li>
                                                    Exercise: 15-30 minutes of elevated heart rate activity.
                                                </li>
                                                <li>
                                                    Intense Exercise: 45-120 minutes of high heart rate activity.
                                                </li>
                                                <li>
                                                    Very Intense Exercise: Over 2 hours of high heart rate activity.
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <br />
                                {statusCode === 400 && <div className="alert alert-warning"><b><u> Error Occurred:</u></b> Please enter all fields correctly. </div>}
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <RelatedLinks />
                            <hr />
                        </div>
                    </div>
                </div>
                <div className="col" >
                    <SecondAds />
                    <br />
                    <MainCalculatorsList CalculatorsTypeId={CalculatorsType.healthCalculators}></MainCalculatorsList>
                    <br />
                </div>
            </div>
            <div className="row" style={{ height: 'auto' }} >
                <div className="col-12 col-md-8">
                    <div className="info-sections-container">
                        <div className="info-section">
                            <div className="info-section-header">Basal Metabolic Rate (BMR) and How to Calculate It</div>
                            <div className="info-section-body">
                                <u><h2 style={{ fontSize: '16px' }}>Basal Metabolic Rate (BMR) and How to Calculate It</h2></u> <br />
                                <p>
                                    Basal Metabolic Rate (BMR) is an important factor that plays a crucial role in understanding your basic calorie needs. Calculating BMR is a fundamental step for weight loss or maintaining a healthy weight. In this article, we will take a look at the concept of BMR and how to calculate it, as well as the importance of knowing your BMR level.
                                </p>
                                <hr />
                                <u><h2 style={{ fontSize: '16px' }}>What is Basal Metabolic Rate (BMR)?</h2></u> <br />
                                <p>
                                    Basal Metabolic Rate (BMR) represents the calories your body needs to perform its vital functions while at complete rest. This is related to the energy required to support basic bodily processes such as breathing, blood circulation, and cell maintenance. BMR can vary from person to person based on factors like age, gender, weight, and height.
                                </p>
                                <hr />
                                <u><h2 style={{ fontSize: '16px' }}>The Importance of Basal Metabolic Rate for Health</h2></u> <br />
                                <p>
                                    Knowing your BMR is an initial step in determining your daily calorie needs. BMR can be used as a starting point to calculate the calories you need daily. This calculation helps determine how many calories you should consume to maintain your current weight or achieve weight loss goals safely.
                                </p>
                                <hr />
                                <u><h2 style={{ fontSize: '16px' }}>How Does Basal Metabolic Rate Affect Weight Loss?</h2></u> <br />
                                <p>
                                    To achieve weight loss, you need to create a calorie deficit, which is the difference between the calories you consume and those your body needs. When you know your BMR, you can calculate the calories you need to consume.
                                </p>
                                <hr />
                                <u><h2 style={{ fontSize: '16px' }}>How to Calculate Basal Metabolic Rate (BMR)</h2></u>
                                We use 7 different equations in this calculator to calculate Basal Metabolic Rate as shown below:
                                <br/>                                <div>
                                    <b>Harris-Benedict Equation (Original):</b><br />
                                    The original Harris-Benedict formula is one of the most commonly used formulas online to calculate your daily energy needs. However, it is also one of the least accurate formulas.
                                    <u>Calculated as follows:</u> <br />
                                    <br />  <div className="alert alert-info" >
                                        <ul>
                                            <li>
                                                Males: 66.4730 + (13.7516 x weight [kg]) + (5.0033 x height [cm]) - (6.7550 x age)
                                            </li>
                                            <li>
                                                Females: 655.0955 + (9.5634 x weight [kg]) + (1.8496 x height [cm]) - (4.6756 x age)
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <br />
                                <div>
                                    <b>Harris Benedict Equation (Revised):</b><br />
                                    In 1984, the Harris-Benedict formula was revised by Roza and Shizgal. A larger research group was used in this modification.
                                    <u>Calculated as follows:</u> <br />
                                    <br />  <div className="alert alert-info" >
                                        <ul>
                                            <li>
                                                Males: 88.362 + (13.397 x weight [kg]) + (4.799 x height [cm]) - (5.677 x age)
                                            </li>
                                            <li>
                                                Females: 447.593 + (9.247 x weight [kg]) + (3.098 x height [cm]) - (4.33 x age)
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <br />
                                <div>
                                    <b>Mifflin-St Jeor:</b><br />
                                    In 1990, the Mifflin-St Jeor equation was introduced. In 2005, the American Dietetic Association (ADA) compared the basal metabolic rate equations of Harris-Benedict, Mifflin-St Jeor, Owen, and the World Health Organization/Food and Agriculture Organization/United Nations University (WHO/FAO/UNU) and found that the Mifflin-St Jeor equation is the most accurate, predicting basal metabolic rate with an accuracy of up to 10% of measured values.
                                    <u>Calculated as follows:</u> <br />
                                    <br />  <div className="alert alert-info" >
                                        <ul>
                                            <li>
                                                Males: (9.99 x weight [kg]) + (6.25 x height [cm]) - (4.92 x age) + 5
                                            </li>
                                            <li>
                                                Females: (9.99 x weight [kg]) + (6.25 x height [cm]) - (4.92 x age) - 161
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <br />
                                <div>
                                    <b>Schofield:</b><br />
                                    The Schofield equation was published in 1985 and was used by the Food and Agriculture Organization/World Health Organization/United Nations University (FAO/WHO/UNU) and others. However, there was a disproportionately high number of participants in the dataset who were Italian men with higher basal metabolic rates on average. This unfairly influenced the results for other populations.
                                    <u>Calculated as follows:</u> <br/>                                    <b>Males:</b> <br />
                                    <table >
                                        <thead >
                                            <tr>
                                                <th className="formula-header">Age</th>
                                                <th className="formula-header">Equation</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>0-3</td>
                                                <td>61.0 x weight [kg] - 33.7</td>
                                            </tr>
                                            <tr>
                                                <td>3-10</td>
                                                <td>23.3 x weight [kg] + 514</td>
                                            </tr>
                                            <tr>
                                                <td>10-18</td>
                                                <td>18.4 x weight [kg] + 581</td>
                                            </tr>
                                            <tr>
                                                <td>18-30</td>
                                                <td>16.0 x weight [kg] + 545</td>
                                            </tr>
                                            <tr>
                                                <td>30-60</td>
                                                <td>14.2 x weight [kg] + 593</td>
                                            </tr>
                                            <tr>
                                                <td>60+</td>
                                                <td>13.5 x weight [kg] + 514</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <br />
                                    <b>Females:</b> <br />
                                    <table >
                                        <thead >
                                            <tr>
                                                <th className="formula-header">Age</th>
                                                <th className="formula-header">Equation</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>0-3</td>
                                                <td>58.317 x weight [kg] - 31.1</td>
                                            </tr>
                                            <tr>
                                                <td>3-10</td>
                                                <td>20.315 x weight [kg] + 485.9</td>
                                            </tr>
                                            <tr>
                                                <td>10-18</td>
                                                <td>13.384 x weight [kg] + 692.6</td>
                                            </tr>
                                            <tr>
                                                <td>18-30</td>
                                                <td>14.818 x weight [kg] + 486.6</td>
                                            </tr>
                                            <tr>
                                                <td>30-60</td>
                                                <td>8.126 x weight [kg] + 845.6</td>
                                            </tr>
                                            <tr>
                                                <td>60+</td>
                                                <td>9.082 x weight [kg] + 658.5</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <br />
                                </div>
                                <br />
                                <div>
                                    <b>Oxford:</b><br />
                                    As shown by the equation mentioned earlier, the reliability of the Schofield equation has been proven unreliable for many individuals. Therefore, a new series of equations was developed in 2005, known for relying on a database containing 10,552 basal metabolic rate values, including a more diverse group of study participants.
                                    <u>Calculated as follows:</u> <br/>                                    <b>Males:</b> <br />
                                    <table >
                                        <thead >
                                            <tr>
                                                <th className="formula-header">Age</th>
                                                <th className="formula-header">Equation</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>0-3</td>
                                                <td>61.0 x weight [kg] - 33.7</td>
                                            </tr>
                                            <tr>
                                                <td>3-10</td>
                                                <td>23.3 x weight [kg] + 514</td>
                                            </tr>
                                            <tr>
                                                <td>10-18</td>
                                                <td>18.4 x weight [kg] + 581</td>
                                            </tr>
                                            <tr>
                                                <td>18-30</td>
                                                <td>16.0 x weight [kg] + 545</td>
                                            </tr>
                                            <tr>
                                                <td>30-60</td>
                                                <td>14.2 x weight [kg] + 593</td>
                                            </tr>
                                            <tr>
                                                <td>60+</td>
                                                <td>13.5 x weight [kg] + 514</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <br />
                                    <b>Females:</b> <br />
                                    <table >
                                        <thead>
                                            <tr>
                                                <th className="formula-header">Age</th>
                                                <th className="formula-header">Equation</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>0-3</td>
                                                <td>58.9 x Weight [kg] - 23.1</td>
                                            </tr>
                                            <tr>
                                                <td>3-10</td>
                                                <td>20.1 x Weight [kg] + 507</td>
                                            </tr>
                                            <tr>
                                                <td>10-18</td>
                                                <td>11.1 x Weight [kg] + 761</td>
                                            </tr>
                                            <tr>
                                                <td>18-30</td>
                                                <td>13.1 x Weight [kg] + 558</td>
                                            </tr>
                                            <tr>
                                                <td>30-60</td>
                                                <td>9.74 x Weight [kg] + 694</td>
                                            </tr>
                                            <tr>
                                                <td>60+</td>
                                                <td>10.1 x Weight [kg] + 569</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <br />
                                <div>
                                    <b>Katch-McArdle:</b><br />
                                    Both the Katch-McArdle and Cunningham equations use lean body mass to estimate basal metabolic rate at rest. If you know your body fat percentage, you can calculate lean body mass using the following formula: (1 - body fat percentage / 100) × weight. Please note that in the above basal metabolic rate/resting metabolic rate calculator, lean body mass is automatically calculated using the power formula if body fat percentage is not provided.
                                    <u>Calculated as follows:</u> <br />
                                    <br />  <div className="alert alert-info" >
                                        <ul>
                                            <li>
                                                370 + (21.6 x Lean Body Mass [kg])
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <br />
                                <div>
                                    <b>Cunningham:</b><br />
                                    The Cunningham equation is more accurate for highly athletic individuals.
                                    <u>Calculated as follows:</u>   <br />
                                    <br />  <div className="alert alert-info" >
                                        <ul>
                                            <li>
                                                500 + (22 x Lean Body Mass [kg])
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <hr />
                                <u><h2 style={{ fontSize: '16px' }}> Some Key Benefits of Calculating BMR Include </h2> </u>
                                <ul>
                                    <li>
                                        Determining your basic nutritional needs: Calculating BMR helps you estimate the basic calories your body needs to maintain its fundamental functions. This means you can determine the amount of energy you need daily based on these basic numbers.
                                    </li>
                                    <li>
                                        Planning your diet according to goals: If you aim to gain or lose weight, you can use BMR as a basis to calculate the number of calories needed to achieve these goals. Increasing calories can help you gain weight, while reducing them can help you lose weight.
                                    </li>
                                    <li>
                                        Planning exercises and physical activity: BMR can be used to determine the number of calories you can burn during exercise and physical activity. This can help you plan your exercise schedule and choose suitable activities to achieve your health and fitness goals.
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <br />
                    <u><h2>Frequently Asked Questions</h2></u>
                    <br />
                    <div className="info-sections-container">
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>What is a good Basal Metabolic Rate (BMR) for my age?</h3>
                            </div>
                            <div className="info-section-body">
                                A good Basal Metabolic Rate (BMR) for your age depends on more than just age itself - gender, height, and weight also play a role. Further research indicates that every ten years, adults experience a 1% to 2% decrease in BMR due to the loss of skeletal muscles. It's safe to say that if you maintain a healthy weight by following healthy lifestyle recommendations, you can maintain a healthy BMR for your age.
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>What is the most accurate BMR calculator?</h3>
                            </div>
                            <div className="info-section-body">
                                There are several commonly used formulas to calculate BMR, including (but not limited to) the Modified Harris-Benedict equation, the Katch-McArdle equation, and the Mifflin-St Jeor equation. Currently, experts consider the Mifflin-St Jeor equation to be the most accurate, which is why we use it in our calculator above.
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>Should I eat my BMR for weight loss?</h3>
                            </div>
                            <div className="info-section-body">
                                Since BMR represents the amount of energy your body needs to maintain its vital functions daily, regularly consuming less than your BMR is not advisable. Just like any low-calorie restrictive diet, your body will respond instinctively by storing more energy rather than using it, expecting a limited supply of new energy. Instead, you can consider these expert-approved tips for safe and sustainable weight loss.
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>What is Basal Metabolic Rate used for?</h3>
                            </div>
                            <div className="info-section-body">
                                Basal Metabolic Rate is used to help individuals and their healthcare providers understand the amount of energy (or calorie) their body needs to maintain its vital functions daily. With this information in mind, individuals can better understand their basic energy needs, and experts can start designing a variety of health interventions, such as diet plans or tailored exercises, for those individuals' well-being goals in a safe, effective, and sustainable manner.
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>Is it better to have a high or low Basal Metabolic Rate (BMR)?</h3>
                            </div>
                            <div className="info-section-body">
                                It's neither better nor worse to have a high or low BMR - the measurement simply correlates with a person's fat-free body mass, and it's not always an indicator of optimal health. For example, an obese person is likely to have a higher BMR than a non-obese person because they need more energy for weight-bearing activities like walking and standing. At the same time, a lean person with a large muscle mass is likely to have a higher BMR than a lean person without much muscle mass for similar reasons. The optimal BMR rate depends on the individual, their health status, and their specific health goals.
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>Should my BMR decrease with weight loss?</h3>
                            </div>
                            <div className="info-section-body">
                                In short, it depends on the weight loss strategies used. Many people who lose weight through calorie restriction alone will eventually decrease their body's energy expenditure (and BMR) due to how metabolism adapts to this restriction. However, a person who loses body fat while increasing muscle mass may lose weight more slowly but is likely to increase their BMR due to changes in their body composition.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default BMRCalculator;
